import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Route } from "../../routes/Route";
import { selectUserData } from "../../store/user/selectors";
import { Role } from "../../types/Role";
import { isVisitor as isVisitorJwt } from "../../utils/auth";

const VisitorGuard = (props: PropsWithChildren) => {
    const userData = useSelector(selectUserData);
    const isVisitor =
        isVisitorJwt() ||
        (userData?.roles?.includes(Role.Visitor) ?? false);

    if (isVisitor) {
        return <Navigate to={`/${Route.Statistics}`} replace />;
    }
    // @ts-ignore
    return <>{props.children}</>;
};

export default VisitorGuard;
